import {
  ObservableState,
  persistentReducedStream,
  reducer,
  streamReducer,
} from '@ardoq/rxbeach';
import {
  type ComponentSelection,
  clearGraphSelection,
  componentGraphSelectionChanged,
  componentSelectionOperations,
  componentTreeSelectionChanged,
  selectionToggle,
} from '@ardoq/component-selection';
import { contextSelection$ } from './contextSelection$';

/**
 * The main model for the component selection in our app. It can contain
 * workspace ids.
 * Spec: https://ardoqcom.atlassian.net/wiki/spaces/PRODUCT/pages/3163586586/Multi+Selection
 */
export const componentSelection$: ObservableState<ComponentSelection> =
  persistentReducedStream(
    'componentSelection$',
    {
      graphSelection: [],
      treeSelection: [],
      selectionStart: '',
    },
    [
      streamReducer(
        contextSelection$,
        componentSelectionOperations.contextSelectionChanged
      ),
      reducer(
        componentGraphSelectionChanged,
        componentSelectionOperations.componentGraphSelectionChanged
      ),
      reducer(
        componentTreeSelectionChanged,
        componentSelectionOperations.componentTreeSelectionChanged
      ),
      reducer(
        selectionToggle,
        componentSelectionOperations.toggleTreeSelectionKeepingSelectionStart
      ),
      reducer(
        clearGraphSelection,
        componentSelectionOperations.clearGraphSelection
      ),
    ]
  );
